<forge-toolbar slot="header" role="group" style="outline: none; position: relative;" tabindex="0" no-divider>
  <forge-avatar slot="start" [text]="model.$emblemText" attr.telemetry="emblemText" class="tt-margin--right"></forge-avatar>

  <div slot="start" fxLayout="column" fxLayoutAlign="center start" class="truncate" style="margin-top: 6px;">
    <div fxLayout="row" class="forge-typography--heading2">
      <div class="truncate" attr.telemetry="title">{{model.$title}}</div>
    </div>
    @if (subtitles.length > 0) {
      <div fxLayout="row" style="width: 100%;">
        @for (kvp of subtitles; track kvp) {
          <div fxLayout="row"
            [ngClass]="{'content-display': $last}">
            <div class="truncate forge-typography--label2" [attr.telemetry]="kvp.Value">{{kvp.Value}}</div>
            @if (!$last) {
              <div>&nbsp; &bull; &nbsp;</div>
            }
          </div>
        }
      </div>
    }
  </div>

  <metadata-action-menu slot="end" [metadataActions]="cardMetadata.Actions" [model]="model" [formData]="datacontroller">
</metadata-action-menu>

@if (hasBody) {
  <forge-open-icon slot="end"></forge-open-icon>
}

<forge-focus-indicator inward focus-mode="focus" style="border-radius: 4px;"></forge-focus-indicator>
<forge-state-layer></forge-state-layer>
</forge-toolbar>
